import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiSelectComponent } from '@app/components/filter-group/multi-select/multi-select.component';
import { ModalComponent } from '@app/components/info-modal/modal/modal.component';
import { DoubleValueLabelPair } from '@app/models/data-types/double-value-label-pair';
import { ModalItem } from '@app/models/elements/modal-item';
import { ContextualizedSelectsFilterConfig } from '@app/models/filters/contextualized-selects-filter-config';
import { FilterStatus } from '@app/models/filters/filter-status';
import { GenericFilterConfig } from '@app/models/filters/generic-filter-config';

@Component({
	selector: 'app-contextualized-selects',
	standalone: true,
	imports: [MultiSelectComponent, ModalComponent],
	templateUrl: './contextualized-selects.component.html',
	styleUrl: './contextualized-selects.component.css',
})
export class ContextualizedSelectsComponent {
	@Input() genericConfig: GenericFilterConfig = {} as GenericFilterConfig;
	specificConfig: ContextualizedSelectsFilterConfig = {} as ContextualizedSelectsFilterConfig;

	@Output() optionChanged = new EventEmitter<FilterStatus>();

	secondOptionsFull: DoubleValueLabelPair[] = [];
	modal: ModalItem = {
		header: 'Funzionamento selezione multipla',
		body: "Tieni premuto il tasto CTRL e fai click su un'opzione per selezionarla/deselezionarla",
	};

	ngOnInit() {
		// cast generic filter config to specific
		this.specificConfig = this.genericConfig as ContextualizedSelectsFilterConfig;

		// Load initial full list of options of the second select component
		this.secondOptionsFull = [...this.specificConfig.subfilters.second.options];
	}

	/**
	 *
	 * When some element in the first selected is selected, modifies the second select based on the dependency map.
	 * Propagates selected values of both selects to parent.
	 * @param newStatus
	 */
	onFirstOptionChange = (newStatus: FilterStatus) => {
		let updatedSecondOptions = [...this.secondOptionsFull];

		// When first select's list of selected values is empty (e.g. no provincia is selected)
		// we need to show all values in the second select (e.g. all the comuni)
		if (newStatus.selectedPrimaryValues.length != 0) {
			// look at the dependency map to get the values of the children (second select) of the selected parents (first select)
			let visibleSecondValues = newStatus.selectedPrimaryValues
				.map((v) => this.specificConfig.dependenciesMap[v] || [])
				.flat();
			updatedSecondOptions = this.secondOptionsFull.filter((o) => visibleSecondValues.includes(o.primaryValue));
		}

		// update second select's options list
		this.specificConfig.subfilters.second = {
			...this.specificConfig.subfilters.second,
			options: updatedSecondOptions,
		};

		// propagate selection to parent
		this.optionChanged.emit(newStatus);

		// selected values in the second select are erased at each change in the first
		this.optionChanged.emit({
			filterId: this.specificConfig.subfilters.second.id,
			selectedPrimaryValues: [],
			selectedSecondaryValues: [],
		});
	};

	onSecondOptionChange = (newStatus: FilterStatus) => {
		this.optionChanged.emit(newStatus);
	};
}
